import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { SessionStorageUtils } from '../utils/session-storage';
import { BaseService } from './base.service';
import { SnackBarService } from './snack-bar/snack-bar.service';
import { IAutenticacao } from 'src/app/core/models/autenticacao';
import { IVerificar } from 'src/app/core/models/search';

@Injectable({
  providedIn: 'root'
})
export class DiplomaSearchService {
  
  private sessionStorage = new SessionStorageUtils();

  constructor(private http: HttpClient,
              public baseService: BaseService,
              public snackBar: SnackBarService) { }

  onSearchDiploma(code: string[], token?: string): Observable<any>{    
    const param = code.map((item: string) => `codigo=${item || ''}`).join('&');
    return this.http.get<IVerificar>(`${this.baseService.URL_API}documento/verificar?${param || ''}&token=${token || ''}`, this.baseService.HEADER).pipe(
      map((response: IVerificar) => {
        return response;
      }),
      catchError((error: any) => {
        this.snackBar.openSnackBar(error.error.avisos.notificacoes[0].mensagem, 'Fechar', 'error-snackbar');        
        return error;
      })
    )
  }

  onGetInfoIntitute(url: any, refPath?: any): Observable<any>{
    url = url ? url : '';
    return this.http.get<IAutenticacao>(`${this.baseService.URL_API}autenticacao`, 
      refPath ? this.baseService.getHeaderNoReferer(url, refPath) : 
      this.baseService.getHeaderReferer(url)).pipe(
      map((response: IAutenticacao) => {
        return response;
      }),
      catchError((error: any) => {
        this.snackBar.openSnackBar(error.error.avisos.notificacoes[0].mensagem, 'Fechar', 'error-snackbar');        
        return error;
      })
    )
  }

  
  onGetArchive(code: string, type: string, modelo: string, action?: string): Observable<any>{
    return this.http.get(`${this.baseService.URL_API}documento?codigo=${code}&tipo=${type}&modelo=${modelo}&download=${action == 'download'}`,{
      responseType: 'blob' as 'json',
      ...this.baseService.HEADER
    }).pipe(
      map((response: any) => {
            if(action == 'download'){
              this.downloadFile(response, type);
            }else{              
              this.viewFile(response, type);
            }
            return response;
          }),
      catchError((error: HttpErrorResponse) => this.parseErrorBlob(error))
    )
  }

  parseErrorBlob(err: HttpErrorResponse): Observable<any> {
    const reader: FileReader = new FileReader();

    const obs = Observable.create((observer: any) => {
      reader.onloadend = (e) => {
        observer.error(JSON.parse(reader.result || err.error));
        observer.complete();
      }
    });
    reader.readAsText(err.error);
    return obs;
}
  
  downloadFile(data: any, type: string) {
    let code: string = this.sessionStorage.onGetNumberDiploma();
    let mimeType = type === 'RVDD' || type === 'pdf' ? 'application/pdf' : (type === 'xml' ? 'application/xml' : 'application/octet-stream');
    let blob = new Blob([data], { type: mimeType });
    let url = URL.createObjectURL(blob);
    let fileName = `Diploma-${code}.${type === 'RVDD' ? 'pdf' : type}`;
    // Detecta se é mobile
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    if (isMobile) {
      // Em mobile, apenas abre o arquivo em nova aba (download forçado não é confiável)
      window.open(url, '_blank');
    } else {
      // Desktop: download tradicional
      let element = document.createElement('a');
      element.href = url;
      element.setAttribute('download', fileName);
      document.body.appendChild(element);
      element.click();
      setTimeout(() => {
        document.body.removeChild(element);
        URL.revokeObjectURL(url);
      }, 100);
    }
  }

  viewFile(data: any, type: string) {
    let typeBlob: string = type == 'xml' ? 'application/xml' : 'application/pdf';
    const blob = new Blob([data], { type: typeBlob });
    const url= window.URL.createObjectURL(blob);
    window.open(url);
  }
}
